import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useImperativeHandle, forwardRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Alert } from '@tribeplatform/react-ui-kit/Alert';
export const Form = forwardRef(({ defaultValues = {}, children, onSubmit, ...rest }, ref) => {
    const methods = useForm({
        defaultValues,
    });
    const [generalErrors, setGeneralErrors] = useState([]);
    const { setError, handleSubmit, formState: { isSubmitSuccessful }, } = methods;
    async function submitForm(data) {
        var _a;
        try {
            setGeneralErrors([]);
            await onSubmit(data, methods);
        }
        catch (err) {
            const errors = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.errors;
            const errMsgs = [];
            errors === null || errors === void 0 ? void 0 : errors.forEach(e => {
                if (e === null || e === void 0 ? void 0 : e.field) {
                    setError(e === null || e === void 0 ? void 0 : e.field, {
                        type: 'validate',
                        message: e === null || e === void 0 ? void 0 : e.message,
                    });
                }
                else if (e === null || e === void 0 ? void 0 : e.message) {
                    errMsgs.push(e);
                }
            });
            if (errMsgs.length) {
                setGeneralErrors(errMsgs);
            }
        }
    }
    useImperativeHandle(ref, () => ({
        methods,
    }));
    if (typeof children === 'function') {
        children = children({ ...methods, submitForm });
    }
    return (_jsx(FormProvider, { ...methods, children: _jsxs("form", { onSubmit: handleSubmit(submitForm), "data-submit-successful": isSubmitSuccessful || undefined, ...rest, children: [(generalErrors === null || generalErrors === void 0 ? void 0 : generalErrors.length) ? (_jsx(Alert, { status: "error", className: "mb-3", children: generalErrors.map(err => {
                        if (!(err === null || err === void 0 ? void 0 : err.message))
                            return null;
                        return _jsx("div", { children: err === null || err === void 0 ? void 0 : err.message }, err === null || err === void 0 ? void 0 : err.message);
                    }) }, void 0)) : null, children] }, void 0) }, void 0));
});
//# sourceMappingURL=Form.js.map